import { tenantConstants } from "../actions/constants/tenantConstants";

export const getTenantListReducer = (state = {}, action: any) => {
  switch (action.type) {
    case tenantConstants.getTenantListRequest:
      return {
        isLoading: true,
        isSuccess: false,
        isError: false,
      };
    case tenantConstants.getTenantListSuccess:
      return {
        isLoading: false,
        isSuccess: true,
        isError: false,
        tenantData: action.payload,
      };
    case tenantConstants.getTenantListFailure:
      return {
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const getHeaderTenantListReducer = (state = {}, action: any) => {
  switch (action.type) {
    case tenantConstants.getHeaderTenantListRequest:
      return {
        isLoading: true,
        isSuccess: false,
        isError: false,
      };
    case tenantConstants.getHeaderTenantListSuccess:
      return {
        isLoading: false,
        isSuccess: true,
        isError: false,
        tenantData: action.payload,
      };
    case tenantConstants.getHeaderTenantListFailure:
      return {
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const saveTenantReducer = (state = {}, action: any) => {
  switch (action.type) {
    case tenantConstants.tenantSaveRequest:
      return {
        isLoading: true,
        isSuccess: false,
        isError: false,
      };
    case tenantConstants.tenantSaveSuccess:
      return {
        isLoading: false,
        isSuccess: true,
        isError: false,
        tenantData: action.payload,
      };
    case tenantConstants.tenantSaveFailure:
      return {
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const viewTenantReducer = (state = {}, action: any) => {
  switch (action.type) {
    case tenantConstants.tenantViewRequest:
      return {
        isLoading: true,
        isSuccess: false,
        isError: false,
      };
    case tenantConstants.tenantViewSuccess:
      return {
        isLoading: false,
        isSuccess: true,
        isError: false,
        tenantData: action.payload,
      };
    case tenantConstants.tenantViewFailure:
      return {
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      };
    default:
      return state;
  }
};
